import {
  AccountInfo,
  AuthenticationResult,
  InteractionStatus,
  IPublicClientApplication,
  PublicClientApplication,
} from '@azure/msal-browser';
import { BehaviorSubject } from 'rxjs';

import { environment } from '../../../environments/environment';

export const MOCK_ACCOUNT = {
  homeAccountId: 'mock-home-id',
  localAccountId: 'mock-local-id',
  environment: 'login.microsoftonline.com',
  tenantId: 'mock-tenant-id',
  username: 'mock-user@example.com',
  name: 'User, M(Mock)',
};

export const mockInProgress = new BehaviorSubject<InteractionStatus>(
  InteractionStatus.None,
);

export function MSALInstanceMockFactory(): IPublicClientApplication {
  const pca = new PublicClientApplication(environment.msalConfig);

  // 1. Mock Account Retrieval
  pca.getAllAccounts = () => [MOCK_ACCOUNT] as AccountInfo[];
  pca.getActiveAccount = () => MOCK_ACCOUNT as AccountInfo;

  // 2. Mock Login Methods (Prevents Windows/Popups)
  pca.loginPopup = async () => {
    mockInProgress.next(InteractionStatus.Login); // Start login state

    pca.getAllAccounts = () => [MOCK_ACCOUNT] as AccountInfo[];
    pca.getActiveAccount = () => MOCK_ACCOUNT as AccountInfo;

    // Simulate a short delay for realism
    await new Promise((resolve) => setTimeout(resolve, 100));

    mockInProgress.next(InteractionStatus.None); // End interaction
    return Promise.resolve({
      account: MOCK_ACCOUNT,
      accessToken: 'mock-token',
    } as AuthenticationResult);
  };

  // 3. Mock Logout Methods (Prevents Redirects)
  pca.logoutRedirect = async () => {
    mockInProgress.next(InteractionStatus.Logout); // Start logout state

    pca.getAllAccounts = () => [];
    pca.getActiveAccount = () => null;

    await new Promise((resolve) => setTimeout(resolve, 100));

    mockInProgress.next(InteractionStatus.None); // End interaction
    return Promise.resolve();
  };

  pca.logoutPopup = () => {
    console.log('MSW: Mocking logoutPopup');
    pca.getAllAccounts = () => [];
    return Promise.resolve();
  };

  // 4. Mock Token Acquisition for Interceptor
  pca.acquireTokenSilent = () =>
    Promise.resolve({
      accessToken: 'mock-access-token',
      idToken: 'mock-id-token',
      account: MOCK_ACCOUNT,
    } as AuthenticationResult);

  console.log('MSAL: Running in local mode with mock authentication');
  return pca;
}
